/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BalanceReportRequest as BackendCoreApiModelsAppLoyaltyBalanceReportRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/balance-report-request';
import { ChangeMemberStateRequest as BackendCoreApiModelsAppLoyaltyChangeMemberStateRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/change-member-state-request';
import { ChangeRedemptionStateRequest as BackendCoreApiModelsAppLoyaltyChangeRedemptionStateRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/change-redemption-state-request';
import { DeleteCampaignItemRequest as BackendCoreApiModelsAppLoyaltyDeleteCampaignItemRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/delete-campaign-item-request';
import { DeleteCampaignRequest as BackendCoreApiModelsAppLoyaltyDeleteCampaignRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/delete-campaign-request';
import { DeleteTrainingRequest as BackendCoreApiModelsAppLoyaltyDeleteTrainingRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/delete-training-request';
import { ImportBatchCollectionResponse as BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/import-batch-collection-response';
import { ImportBatchListRequest as BackendCoreApiModelsAppLoyaltyImportBatchListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/import-batch-list-request';
import { ImportPointsResponse as BackendCoreApiModelsAppLoyaltyImportPointsResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/import-points-response';
import { LoyaltyAppConfigResponse as BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-app-config-response';
import { LoyaltyBalanceResponse as BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-balance-response';
import { LoyaltyCampaignCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-campaign-collection-response';
import { LoyaltyCampaignListRequest as BackendCoreApiModelsAppLoyaltyLoyaltyCampaignListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-campaign-list-request';
import { LoyaltyMeResponse as BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-me-response';
import { LoyaltyMemberCampaignCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-member-campaign-collection-response';
import { LoyaltyMemberCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-member-collection-response';
import { LoyaltyMemberListRequest as BackendCoreApiModelsAppLoyaltyLoyaltyMemberListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-member-list-request';
import { LoyaltyMemberScopedRequest as BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-member-scoped-request';
import { LoyaltyMemberTrainingCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-member-training-collection-response';
import { LoyaltyMyRedemptionCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-my-redemption-collection-response';
import { LoyaltyMyReportCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-my-report-collection-response';
import { LoyaltyPharmacyCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-pharmacy-collection-response';
import { LoyaltyPharmacyListRequest as BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-pharmacy-list-request';
import { LoyaltyPharmacyProgramCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-pharmacy-program-collection-response';
import { LoyaltyPharmacyProgramListRequest as BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-pharmacy-program-list-request';
import { LoyaltyRegisterRequest as BackendCoreApiModelsAppLoyaltyLoyaltyRegisterRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-register-request';
import { LoyaltyRequestMembershipRequest as BackendCoreApiModelsAppLoyaltyLoyaltyRequestMembershipRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-request-membership-request';
import { LoyaltyResendVerificationRequest as BackendCoreApiModelsAppLoyaltyLoyaltyResendVerificationRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-resend-verification-request';
import { LoyaltyTrainingCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-training-collection-response';
import { LoyaltyTrainingListRequest as BackendCoreApiModelsAppLoyaltyLoyaltyTrainingListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-training-list-request';
import { LoyaltyTrainingResultCollectionResponse as BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-training-result-collection-response';
import { LoyaltyTrainingResultListRequest as BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-training-result-list-request';
import { LoyaltyVerifyEmailRequest as BackendCoreApiModelsAppLoyaltyLoyaltyVerifyEmailRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/loyalty-verify-email-request';
import { MemberBalanceCollectionResponse as BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/member-balance-collection-response';
import { MissingPointReportCollectionResponse as BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/missing-point-report-collection-response';
import { MissingPointReportListRequest as BackendCoreApiModelsAppLoyaltyMissingPointReportListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/missing-point-report-list-request';
import { NotificationActionRequest as BackendCoreApiModelsAppLoyaltyNotificationActionRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/notification-action-request';
import { NotificationCollectionResponse as BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/notification-collection-response';
import { NotificationListRequest as BackendCoreApiModelsAppLoyaltyNotificationListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/notification-list-request';
import { PharmacyStaffRequest as BackendCoreApiModelsAppLoyaltyPharmacyStaffRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-staff-request';
import { PharmacyStaffResponse as BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-staff-response';
import { RedemptionCollectionResponse as BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/redemption-collection-response';
import { RedemptionListRequest as BackendCoreApiModelsAppLoyaltyRedemptionListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/redemption-list-request';
import { RegisterDeviceRequest as BackendCoreApiModelsAppLoyaltyRegisterDeviceRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/register-device-request';
import { ReportMissingPointsRequest as BackendCoreApiModelsAppLoyaltyReportMissingPointsRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/report-missing-points-request';
import { RequestRedemptionRequest as BackendCoreApiModelsAppLoyaltyRequestRedemptionRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/request-redemption-request';
import { ResolveMissingPointReportRequest as BackendCoreApiModelsAppLoyaltyResolveMissingPointReportRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/resolve-missing-point-report-request';
import { RevokeImportBatchRequest as BackendCoreApiModelsAppLoyaltyRevokeImportBatchRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/revoke-import-batch-request';
import { SaveCampaignItemRequest as BackendCoreApiModelsAppLoyaltySaveCampaignItemRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/save-campaign-item-request';
import { SaveCampaignItemResponse as BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/save-campaign-item-response';
import { SaveCampaignRequest as BackendCoreApiModelsAppLoyaltySaveCampaignRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/save-campaign-request';
import { SaveTrainingRequest as BackendCoreApiModelsAppLoyaltySaveTrainingRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/save-training-request';
import { SaveVoucherRequest as BackendCoreApiModelsAppLoyaltySaveVoucherRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/save-voucher-request';
import { SendNotificationRequest as BackendCoreApiModelsAppLoyaltySendNotificationRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/send-notification-request';
import { SentNotificationCollectionResponse as BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/sent-notification-collection-response';
import { SentNotificationListRequest as BackendCoreApiModelsAppLoyaltySentNotificationListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/sent-notification-list-request';
import { SetPharmacyProgramRequest as BackendCoreApiModelsAppLoyaltySetPharmacyProgramRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/set-pharmacy-program-request';
import { SubmitTrainingRequest as BackendCoreApiModelsAppLoyaltySubmitTrainingRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/submit-training-request';
import { SubmitTrainingResponse as BackendCoreApiModelsAppLoyaltySubmitTrainingResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/submit-training-response';
import { UnregisterDeviceRequest as BackendCoreApiModelsAppLoyaltyUnregisterDeviceRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/unregister-device-request';
import { VoucherCollectionResponse as BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/voucher-collection-response';
import { VoucherListRequest as BackendCoreApiModelsAppLoyaltyVoucherListRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/voucher-list-request';
import { BaseRequest as SharedKernelModelsBaseRequest } from '../models/SharedKernel/Models/base-request';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';
import { PharmacyOverviewRequest as BackendCoreApiModelsAppLoyaltyPharmacyOverviewRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-overview-request';
import { PharmacyOverviewResponse as BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-overview-response';
import { PharmacyCampaignsRequest as BackendCoreApiModelsAppLoyaltyPharmacyCampaignsRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-campaigns-request';
import { PharmacyCampaignsResponse as BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-campaigns-response';
import { PharmacyTrainingsRequest as BackendCoreApiModelsAppLoyaltyPharmacyTrainingsRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-trainings-request';
import { PharmacyTrainingsResponse as BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-trainings-response';
import { PharmacyPointsRequest as BackendCoreApiModelsAppLoyaltyPharmacyPointsRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-points-request';
import { PharmacyPointsResponse as BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-points-response';
import { RemindTrainingRequest as BackendCoreApiModelsAppLoyaltyRemindTrainingRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/remind-training-request';
import { PharmacyRedemptionCatalogRequest as BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-redemption-catalog-request';
import { PharmacyRedemptionCatalogResponse as BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-redemption-catalog-response';
import { PharmacyRequestRedemptionRequest as BackendCoreApiModelsAppLoyaltyPharmacyRequestRedemptionRequest } from '../models/Backend/Core/Api/Models/App/Loyalty/pharmacy-request-redemption-request';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loyaltyAdminChangeMemberState
   */
  static readonly LoyaltyAdminChangeMemberStatePath = '/api/loyalty/admin/members/change-state';

  /**
   * Tagság állapotának módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminChangeMemberState$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminChangeMemberState$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyChangeMemberStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminChangeMemberStatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Tagság állapotának módosítása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminChangeMemberState$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminChangeMemberState$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyChangeMemberStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminChangeMemberState$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Tagság állapotának módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminChangeMemberState$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminChangeMemberState$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyChangeMemberStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminChangeMemberStatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Tagság állapotának módosítása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminChangeMemberState$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminChangeMemberState$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyChangeMemberStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminChangeMemberState$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminChangeRedemptionState
   */
  static readonly LoyaltyAdminChangeRedemptionStatePath = '/api/loyalty/admin/redemptions/change-state';

  /**
   * Beváltás állapotváltása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminChangeRedemptionState$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminChangeRedemptionState$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyChangeRedemptionStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminChangeRedemptionStatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Beváltás állapotváltása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminChangeRedemptionState$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminChangeRedemptionState$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyChangeRedemptionStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminChangeRedemptionState$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Beváltás állapotváltása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminChangeRedemptionState$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminChangeRedemptionState$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyChangeRedemptionStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminChangeRedemptionStatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Beváltás állapotváltása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminChangeRedemptionState$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminChangeRedemptionState$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyChangeRedemptionStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminChangeRedemptionState$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminDeleteCampaign
   */
  static readonly LoyaltyAdminDeleteCampaignPath = '/api/loyalty/admin/campaigns/delete';

  /**
   * Kampány törlése (logikai).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminDeleteCampaign$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteCampaign$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteCampaignRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminDeleteCampaignPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Kampány törlése (logikai).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminDeleteCampaign$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteCampaign$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteCampaignRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminDeleteCampaign$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Kampány törlése (logikai).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminDeleteCampaign$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteCampaign$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteCampaignRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminDeleteCampaignPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Kampány törlése (logikai).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminDeleteCampaign$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteCampaign$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteCampaignRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminDeleteCampaign$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminDeleteCampaignItem
   */
  static readonly LoyaltyAdminDeleteCampaignItemPath = '/api/loyalty/admin/campaign-items/delete';

  /**
   * Kampánytermék törlése (logikai).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminDeleteCampaignItem$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteCampaignItem$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteCampaignItemRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminDeleteCampaignItemPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Kampánytermék törlése (logikai).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminDeleteCampaignItem$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteCampaignItem$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteCampaignItemRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminDeleteCampaignItem$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Kampánytermék törlése (logikai).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminDeleteCampaignItem$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteCampaignItem$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteCampaignItemRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminDeleteCampaignItemPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Kampánytermék törlése (logikai).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminDeleteCampaignItem$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteCampaignItem$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteCampaignItemRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminDeleteCampaignItem$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyDeleteNotification
   */
  static readonly LoyaltyDeleteNotificationPath = '/api/loyalty/notifications/delete';

  /**
   * Üzenet törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyDeleteNotification$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyDeleteNotification$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationActionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyDeleteNotificationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Üzenet törlése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyDeleteNotification$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyDeleteNotification$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationActionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyDeleteNotification$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Üzenet törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyDeleteNotification$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyDeleteNotification$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationActionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyDeleteNotificationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Üzenet törlése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyDeleteNotification$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyDeleteNotification$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationActionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyDeleteNotification$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminDeleteTraining
   */
  static readonly LoyaltyAdminDeleteTrainingPath = '/api/loyalty/admin/trainings/delete';

  /**
   * Oktatás törlése (logikai).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminDeleteTraining$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteTraining$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteTrainingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminDeleteTrainingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Oktatás törlése (logikai).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminDeleteTraining$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteTraining$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteTrainingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminDeleteTraining$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Oktatás törlése (logikai).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminDeleteTraining$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteTraining$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteTrainingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminDeleteTrainingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Oktatás törlése (logikai).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminDeleteTraining$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminDeleteTraining$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyDeleteTrainingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminDeleteTraining$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminExportBalances
   */
  static readonly LoyaltyAdminExportBalancesPath = '/api/loyalty/admin/reports/balances/export';

  /**
   * Tagok egyenlege Excelben.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminExportBalances$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminExportBalances$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyBalanceReportRequest
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminExportBalancesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Tagok egyenlege Excelben.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminExportBalances$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminExportBalances$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyBalanceReportRequest
  }): Observable<Blob> {

    return this.loyaltyAdminExportBalances$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Tagok egyenlege Excelben.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminExportBalances$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminExportBalances$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyBalanceReportRequest
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminExportBalancesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Tagok egyenlege Excelben.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminExportBalances$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminExportBalances$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyBalanceReportRequest
  }): Observable<Blob> {

    return this.loyaltyAdminExportBalances$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation loyaltyGetAppConfig
   */
  static readonly LoyaltyGetAppConfigPath = '/api/loyalty/app-config';

  /**
   * Szirom Pont app beállításai.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyGetAppConfig$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  loyaltyGetAppConfig$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyGetAppConfigPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse>;
      })
    );
  }

  /**
   * Szirom Pont app beállításai.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyGetAppConfig$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loyaltyGetAppConfig$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse> {

    return this.loyaltyGetAppConfig$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse)
    );
  }

  /**
   * Szirom Pont app beállításai.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyGetAppConfig$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  loyaltyGetAppConfig$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyGetAppConfigPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse>;
      })
    );
  }

  /**
   * Szirom Pont app beállításai.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyGetAppConfig$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loyaltyGetAppConfig$Json(params?: {
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse> {

    return this.loyaltyGetAppConfig$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyAppConfigResponse)
    );
  }

  /**
   * Path part for operation loyaltyGetBalance
   */
  static readonly LoyaltyGetBalancePath = '/api/loyalty/balance';

  /**
   * Egyenleg és pontmozgások.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyGetBalance$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyGetBalance$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyGetBalancePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse>;
      })
    );
  }

  /**
   * Egyenleg és pontmozgások.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyGetBalance$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyGetBalance$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse> {

    return this.loyaltyGetBalance$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse)
    );
  }

  /**
   * Egyenleg és pontmozgások.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyGetBalance$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyGetBalance$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyGetBalancePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse>;
      })
    );
  }

  /**
   * Egyenleg és pontmozgások.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyGetBalance$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyGetBalance$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse> {

    return this.loyaltyGetBalance$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyBalanceResponse)
    );
  }

  /**
   * Path part for operation loyaltyGetImage
   */
  static readonly LoyaltyGetImagePath = '/api/loyalty/images/{storageId}';

  /**
   * Kampánytermék képe.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyGetImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  loyaltyGetImage$Response(params: {
    storageId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyGetImagePath, 'get');
    if (params) {
      rb.path('storageId', params.storageId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Kampánytermék képe.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyGetImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loyaltyGetImage(params: {
    storageId: string;
  }): Observable<void> {

    return this.loyaltyGetImage$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation loyaltyGetMe
   */
  static readonly LoyaltyGetMePath = '/api/loyalty/me';

  /**
   * Saját adatok és tagságok.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyGetMe$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyGetMe$Plain$Response(params?: {
    body?: SharedKernelModelsBaseRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyGetMePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse>;
      })
    );
  }

  /**
   * Saját adatok és tagságok.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyGetMe$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyGetMe$Plain(params?: {
    body?: SharedKernelModelsBaseRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse> {

    return this.loyaltyGetMe$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse)
    );
  }

  /**
   * Saját adatok és tagságok.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyGetMe$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyGetMe$Json$Response(params?: {
    body?: SharedKernelModelsBaseRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyGetMePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse>;
      })
    );
  }

  /**
   * Saját adatok és tagságok.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyGetMe$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyGetMe$Json(params?: {
    body?: SharedKernelModelsBaseRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse> {

    return this.loyaltyGetMe$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMeResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminImportPoints
   */
  static readonly LoyaltyAdminImportPointsPath = '/api/loyalty/admin/import';

  /**
   * Pontfeltöltés Excelből (ellenőrzés vagy betöltés).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminImportPoints$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  loyaltyAdminImportPoints$Plain$Response(params?: {
    body?: {
'CorrelationId'?: string;
'File': Blob;
'Commit'?: boolean;
}
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportPointsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminImportPointsPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportPointsResponse>;
      })
    );
  }

  /**
   * Pontfeltöltés Excelből (ellenőrzés vagy betöltés).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminImportPoints$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  loyaltyAdminImportPoints$Plain(params?: {
    body?: {
'CorrelationId'?: string;
'File': Blob;
'Commit'?: boolean;
}
  }): Observable<BackendCoreApiModelsAppLoyaltyImportPointsResponse> {

    return this.loyaltyAdminImportPoints$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportPointsResponse>) => r.body as BackendCoreApiModelsAppLoyaltyImportPointsResponse)
    );
  }

  /**
   * Pontfeltöltés Excelből (ellenőrzés vagy betöltés).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminImportPoints$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  loyaltyAdminImportPoints$Json$Response(params?: {
    body?: {
'CorrelationId'?: string;
'File': Blob;
'Commit'?: boolean;
}
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportPointsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminImportPointsPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportPointsResponse>;
      })
    );
  }

  /**
   * Pontfeltöltés Excelből (ellenőrzés vagy betöltés).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminImportPoints$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  loyaltyAdminImportPoints$Json(params?: {
    body?: {
'CorrelationId'?: string;
'File': Blob;
'Commit'?: boolean;
}
  }): Observable<BackendCoreApiModelsAppLoyaltyImportPointsResponse> {

    return this.loyaltyAdminImportPoints$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportPointsResponse>) => r.body as BackendCoreApiModelsAppLoyaltyImportPointsResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListBalances
   */
  static readonly LoyaltyAdminListBalancesPath = '/api/loyalty/admin/reports/balances';

  /**
   * Tagok egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListBalances$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListBalances$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyBalanceReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListBalancesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse>;
      })
    );
  }

  /**
   * Tagok egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListBalances$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListBalances$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyBalanceReportRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse> {

    return this.loyaltyAdminListBalances$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse)
    );
  }

  /**
   * Tagok egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListBalances$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListBalances$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyBalanceReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListBalancesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse>;
      })
    );
  }

  /**
   * Tagok egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListBalances$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListBalances$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyBalanceReportRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse> {

    return this.loyaltyAdminListBalances$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyMemberBalanceCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListCampaigns
   */
  static readonly LoyaltyAdminListCampaignsPath = '/api/loyalty/admin/campaigns/list';

  /**
   * Kampányok termékekkel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListCampaigns$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListCampaigns$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyCampaignListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListCampaignsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse>;
      })
    );
  }

  /**
   * Kampányok termékekkel.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListCampaigns$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListCampaigns$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyCampaignListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse> {

    return this.loyaltyAdminListCampaigns$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse)
    );
  }

  /**
   * Kampányok termékekkel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListCampaigns$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListCampaigns$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyCampaignListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListCampaignsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse>;
      })
    );
  }

  /**
   * Kampányok termékekkel.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListCampaigns$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListCampaigns$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyCampaignListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse> {

    return this.loyaltyAdminListCampaigns$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyCampaignCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyListCampaigns
   */
  static readonly LoyaltyListCampaignsPath = '/api/loyalty/campaigns';

  /**
   * Kampányok a tagnak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListCampaigns$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListCampaigns$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListCampaignsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse>;
      })
    );
  }

  /**
   * Kampányok a tagnak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListCampaigns$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListCampaigns$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse> {

    return this.loyaltyListCampaigns$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse)
    );
  }

  /**
   * Kampányok a tagnak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListCampaigns$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListCampaigns$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListCampaignsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse>;
      })
    );
  }

  /**
   * Kampányok a tagnak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListCampaigns$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListCampaigns$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse> {

    return this.loyaltyListCampaigns$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMemberCampaignCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListImportBatches
   */
  static readonly LoyaltyAdminListImportBatchesPath = '/api/loyalty/admin/import/batches';

  /**
   * Pontfeltöltési kötegek.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListImportBatches$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListImportBatches$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyImportBatchListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListImportBatchesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse>;
      })
    );
  }

  /**
   * Pontfeltöltési kötegek.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListImportBatches$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListImportBatches$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyImportBatchListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse> {

    return this.loyaltyAdminListImportBatches$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse)
    );
  }

  /**
   * Pontfeltöltési kötegek.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListImportBatches$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListImportBatches$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyImportBatchListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListImportBatchesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse>;
      })
    );
  }

  /**
   * Pontfeltöltési kötegek.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListImportBatches$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListImportBatches$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyImportBatchListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse> {

    return this.loyaltyAdminListImportBatches$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyImportBatchCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListMembers
   */
  static readonly LoyaltyAdminListMembersPath = '/api/loyalty/admin/members/list';

  /**
   * Szirom Pont tagságok.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListMembers$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListMembers$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListMembersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse>;
      })
    );
  }

  /**
   * Szirom Pont tagságok.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListMembers$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListMembers$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse> {

    return this.loyaltyAdminListMembers$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse)
    );
  }

  /**
   * Szirom Pont tagságok.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListMembers$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListMembers$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListMembersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse>;
      })
    );
  }

  /**
   * Szirom Pont tagságok.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListMembers$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListMembers$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse> {

    return this.loyaltyAdminListMembers$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMemberCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListMissingPointReports
   */
  static readonly LoyaltyAdminListMissingPointReportsPath = '/api/loyalty/admin/reports/list';

  /**
   * Hiányzó pont bejelentések.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListMissingPointReports$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListMissingPointReports$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyMissingPointReportListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListMissingPointReportsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse>;
      })
    );
  }

  /**
   * Hiányzó pont bejelentések.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListMissingPointReports$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListMissingPointReports$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyMissingPointReportListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse> {

    return this.loyaltyAdminListMissingPointReports$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse)
    );
  }

  /**
   * Hiányzó pont bejelentések.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListMissingPointReports$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListMissingPointReports$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyMissingPointReportListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListMissingPointReportsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse>;
      })
    );
  }

  /**
   * Hiányzó pont bejelentések.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListMissingPointReports$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListMissingPointReports$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyMissingPointReportListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse> {

    return this.loyaltyAdminListMissingPointReports$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyMissingPointReportCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyListMyRedemptions
   */
  static readonly LoyaltyListMyRedemptionsPath = '/api/loyalty/redemptions/mine';

  /**
   * Saját beváltások.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListMyRedemptions$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListMyRedemptions$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListMyRedemptionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse>;
      })
    );
  }

  /**
   * Saját beváltások.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListMyRedemptions$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListMyRedemptions$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse> {

    return this.loyaltyListMyRedemptions$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse)
    );
  }

  /**
   * Saját beváltások.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListMyRedemptions$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListMyRedemptions$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListMyRedemptionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse>;
      })
    );
  }

  /**
   * Saját beváltások.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListMyRedemptions$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListMyRedemptions$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse> {

    return this.loyaltyListMyRedemptions$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMyRedemptionCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyListMyReports
   */
  static readonly LoyaltyListMyReportsPath = '/api/loyalty/reports/mine';

  /**
   * Saját bejelentések.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListMyReports$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListMyReports$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListMyReportsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse>;
      })
    );
  }

  /**
   * Saját bejelentések.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListMyReports$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListMyReports$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse> {

    return this.loyaltyListMyReports$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse)
    );
  }

  /**
   * Saját bejelentések.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListMyReports$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListMyReports$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListMyReportsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse>;
      })
    );
  }

  /**
   * Saját bejelentések.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListMyReports$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListMyReports$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse> {

    return this.loyaltyListMyReports$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMyReportCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyListNotifications
   */
  static readonly LoyaltyListNotificationsPath = '/api/loyalty/notifications';

  /**
   * Üzenetek a tagnak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListNotifications$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListNotifications$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListNotificationsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse>;
      })
    );
  }

  /**
   * Üzenetek a tagnak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListNotifications$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListNotifications$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse> {

    return this.loyaltyListNotifications$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse)
    );
  }

  /**
   * Üzenetek a tagnak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListNotifications$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListNotifications$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListNotificationsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse>;
      })
    );
  }

  /**
   * Üzenetek a tagnak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListNotifications$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListNotifications$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse> {

    return this.loyaltyListNotifications$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyNotificationCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyListPharmacies
   */
  static readonly LoyaltyListPharmaciesPath = '/api/loyalty/pharmacies';

  /**
   * Választható patikák a Szirom Pont regisztrációhoz.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListPharmacies$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListPharmacies$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListPharmaciesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse>;
      })
    );
  }

  /**
   * Választható patikák a Szirom Pont regisztrációhoz.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListPharmacies$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListPharmacies$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse> {

    return this.loyaltyListPharmacies$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse)
    );
  }

  /**
   * Választható patikák a Szirom Pont regisztrációhoz.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListPharmacies$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListPharmacies$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListPharmaciesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse>;
      })
    );
  }

  /**
   * Választható patikák a Szirom Pont regisztrációhoz.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListPharmacies$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListPharmacies$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse> {

    return this.loyaltyListPharmacies$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListPharmacies
   */
  static readonly LoyaltyAdminListPharmaciesPath = '/api/loyalty/admin/pharmacies/list';

  /**
   * Patikák részvétele a Szirom Pont programban.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListPharmacies$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListPharmacies$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListPharmaciesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse>;
      })
    );
  }

  /**
   * Patikák részvétele a Szirom Pont programban.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListPharmacies$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListPharmacies$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse> {

    return this.loyaltyAdminListPharmacies$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse)
    );
  }

  /**
   * Patikák részvétele a Szirom Pont programban.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListPharmacies$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListPharmacies$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListPharmaciesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse>;
      })
    );
  }

  /**
   * Patikák részvétele a Szirom Pont programban.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListPharmacies$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListPharmacies$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse> {

    return this.loyaltyAdminListPharmacies$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyPharmacyProgramCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyPharmacyStaff
   */
  static readonly LoyaltyPharmacyStaffPath = '/api/loyalty/pharmacy/staff';

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyStaff$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyStaff$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyStaffRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyStaffPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyStaff$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyStaff$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyStaffRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse> {

    return this.loyaltyPharmacyStaff$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse)
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyStaff$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyStaff$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyStaffRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyStaffPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyStaff$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyStaff$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyStaffRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse> {

    return this.loyaltyPharmacyStaff$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyStaffResponse)
    );
  }
  /**
   * Path part for operation loyaltyPharmacyRedemptions
   */
  static readonly LoyaltyPharmacyRedemptionsPath = '/api/loyalty/pharmacy/redemptions';

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyRedemptions$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRedemptions$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyRedemptionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyRedemptions$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRedemptions$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse> {

    return this.loyaltyPharmacyRedemptions$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse)
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyRedemptions$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRedemptions$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyRedemptionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyRedemptions$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRedemptions$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse> {

    return this.loyaltyPharmacyRedemptions$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyRedemptionCatalogResponse)
    );
  }
  /**
   * Path part for operation loyaltyPharmacyRequestRedemption
   */
  static readonly LoyaltyPharmacyRequestRedemptionPath = '/api/loyalty/pharmacy/redemptions/request';

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyRequestRedemption$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRequestRedemption$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyRequestRedemptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyRequestRedemptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyRequestRedemption$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRequestRedemption$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyRequestRedemptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyPharmacyRequestRedemption$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyRequestRedemption$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRequestRedemption$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyRequestRedemptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyRequestRedemptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyRequestRedemption$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRequestRedemption$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyRequestRedemptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyPharmacyRequestRedemption$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }
  /**
   * Path part for operation loyaltyPharmacyOverview
   */
  static readonly LoyaltyPharmacyOverviewPath = '/api/loyalty/pharmacy/overview';

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyOverview$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyOverview$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyOverviewRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyOverviewPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyOverview$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyOverview$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyOverviewRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse> {

    return this.loyaltyPharmacyOverview$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse)
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyOverview$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyOverview$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyOverviewRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyOverviewPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyOverview$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyOverview$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyOverviewRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse> {

    return this.loyaltyPharmacyOverview$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyOverviewResponse)
    );
  }
  /**
   * Path part for operation loyaltyPharmacyCampaigns
   */
  static readonly LoyaltyPharmacyCampaignsPath = '/api/loyalty/pharmacy/campaigns';

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyCampaigns$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyCampaigns$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyCampaignsRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyCampaignsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyCampaigns$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyCampaigns$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyCampaignsRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse> {

    return this.loyaltyPharmacyCampaigns$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse)
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyCampaigns$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyCampaigns$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyCampaignsRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyCampaignsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyCampaigns$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyCampaigns$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyCampaignsRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse> {

    return this.loyaltyPharmacyCampaigns$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyCampaignsResponse)
    );
  }
  /**
   * Path part for operation loyaltyPharmacyTrainings
   */
  static readonly LoyaltyPharmacyTrainingsPath = '/api/loyalty/pharmacy/trainings';

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyTrainings$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyTrainings$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyTrainingsRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyTrainingsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyTrainings$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyTrainings$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyTrainingsRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse> {

    return this.loyaltyPharmacyTrainings$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse)
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyTrainings$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyTrainings$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyTrainingsRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyTrainingsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyTrainings$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyTrainings$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyTrainingsRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse> {

    return this.loyaltyPharmacyTrainings$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyTrainingsResponse)
    );
  }
  /**
   * Path part for operation loyaltyPharmacyPoints
   */
  static readonly LoyaltyPharmacyPointsPath = '/api/loyalty/pharmacy/points';

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyPoints$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyPoints$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyPointsRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyPointsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyPoints$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyPoints$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyPointsRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse> {

    return this.loyaltyPharmacyPoints$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse)
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyPoints$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyPoints$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyPointsRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyPointsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyPoints$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyPoints$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyPharmacyPointsRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse> {

    return this.loyaltyPharmacyPoints$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse>) => r.body as BackendCoreApiModelsAppLoyaltyPharmacyPointsResponse)
    );
  }
  /**
   * Path part for operation loyaltyPharmacyRemindTraining
   */
  static readonly LoyaltyPharmacyRemindTrainingPath = '/api/loyalty/pharmacy/trainings/remind';

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyRemindTraining$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRemindTraining$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRemindTrainingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyRemindTrainingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyRemindTraining$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRemindTraining$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRemindTrainingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyPharmacyRemindTraining$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyPharmacyRemindTraining$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRemindTraining$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRemindTrainingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyPharmacyRemindTrainingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * A patika dolgozóinak Szirom Pont egyenlege.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyPharmacyRemindTraining$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyPharmacyRemindTraining$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRemindTrainingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyPharmacyRemindTraining$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListRedemptions
   */
  static readonly LoyaltyAdminListRedemptionsPath = '/api/loyalty/admin/redemptions/list';

  /**
   * Beváltási kérések.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListRedemptions$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListRedemptions$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRedemptionListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListRedemptionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse>;
      })
    );
  }

  /**
   * Beváltási kérések.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListRedemptions$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListRedemptions$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRedemptionListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse> {

    return this.loyaltyAdminListRedemptions$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse)
    );
  }

  /**
   * Beváltási kérések.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListRedemptions$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListRedemptions$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRedemptionListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListRedemptionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse>;
      })
    );
  }

  /**
   * Beváltási kérések.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListRedemptions$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListRedemptions$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRedemptionListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse> {

    return this.loyaltyAdminListRedemptions$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyRedemptionCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListSentNotifications
   */
  static readonly LoyaltyAdminListSentNotificationsPath = '/api/loyalty/admin/notifications/list';

  /**
   * Kiküldött üzenetek kötegenként.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListSentNotifications$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListSentNotifications$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySentNotificationListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListSentNotificationsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse>;
      })
    );
  }

  /**
   * Kiküldött üzenetek kötegenként.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListSentNotifications$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListSentNotifications$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltySentNotificationListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse> {

    return this.loyaltyAdminListSentNotifications$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse)
    );
  }

  /**
   * Kiküldött üzenetek kötegenként.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListSentNotifications$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListSentNotifications$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySentNotificationListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListSentNotificationsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse>;
      })
    );
  }

  /**
   * Kiküldött üzenetek kötegenként.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListSentNotifications$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListSentNotifications$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltySentNotificationListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse> {

    return this.loyaltyAdminListSentNotifications$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltySentNotificationCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListTrainingResults
   */
  static readonly LoyaltyAdminListTrainingResultsPath = '/api/loyalty/admin/trainings/results';

  /**
   * Oktatási eredmények.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListTrainingResults$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListTrainingResults$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListTrainingResultsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse>;
      })
    );
  }

  /**
   * Oktatási eredmények.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListTrainingResults$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListTrainingResults$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse> {

    return this.loyaltyAdminListTrainingResults$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse)
    );
  }

  /**
   * Oktatási eredmények.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListTrainingResults$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListTrainingResults$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListTrainingResultsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse>;
      })
    );
  }

  /**
   * Oktatási eredmények.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListTrainingResults$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListTrainingResults$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse> {

    return this.loyaltyAdminListTrainingResults$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyTrainingResultCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListTrainings
   */
  static readonly LoyaltyAdminListTrainingsPath = '/api/loyalty/admin/trainings/list';

  /**
   * Oktatások kérdésekkel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListTrainings$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListTrainings$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyTrainingListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListTrainingsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse>;
      })
    );
  }

  /**
   * Oktatások kérdésekkel.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListTrainings$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListTrainings$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyTrainingListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse> {

    return this.loyaltyAdminListTrainings$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse)
    );
  }

  /**
   * Oktatások kérdésekkel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListTrainings$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListTrainings$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyTrainingListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListTrainingsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse>;
      })
    );
  }

  /**
   * Oktatások kérdésekkel.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListTrainings$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListTrainings$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyTrainingListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse> {

    return this.loyaltyAdminListTrainings$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyTrainingCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyListTrainings
   */
  static readonly LoyaltyListTrainingsPath = '/api/loyalty/trainings';

  /**
   * Oktatások a tagnak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListTrainings$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListTrainings$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListTrainingsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse>;
      })
    );
  }

  /**
   * Oktatások a tagnak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListTrainings$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListTrainings$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse> {

    return this.loyaltyListTrainings$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse)
    );
  }

  /**
   * Oktatások a tagnak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListTrainings$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListTrainings$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListTrainingsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse>;
      })
    );
  }

  /**
   * Oktatások a tagnak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListTrainings$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListTrainings$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse> {

    return this.loyaltyListTrainings$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyLoyaltyMemberTrainingCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminListVouchers
   */
  static readonly LoyaltyAdminListVouchersPath = '/api/loyalty/admin/vouchers/list';

  /**
   * Utalványkatalógus (admin).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListVouchers$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListVouchers$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyVoucherListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListVouchersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>;
      })
    );
  }

  /**
   * Utalványkatalógus (admin).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListVouchers$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListVouchers$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyVoucherListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse> {

    return this.loyaltyAdminListVouchers$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse)
    );
  }

  /**
   * Utalványkatalógus (admin).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminListVouchers$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListVouchers$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyVoucherListRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminListVouchersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>;
      })
    );
  }

  /**
   * Utalványkatalógus (admin).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminListVouchers$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminListVouchers$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyVoucherListRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse> {

    return this.loyaltyAdminListVouchers$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyListVouchers
   */
  static readonly LoyaltyListVouchersPath = '/api/loyalty/vouchers';

  /**
   * Utalványkatalógus a tagnak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListVouchers$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListVouchers$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListVouchersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>;
      })
    );
  }

  /**
   * Utalványkatalógus a tagnak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListVouchers$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListVouchers$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse> {

    return this.loyaltyListVouchers$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse)
    );
  }

  /**
   * Utalványkatalógus a tagnak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyListVouchers$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListVouchers$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyListVouchersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>;
      })
    );
  }

  /**
   * Utalványkatalógus a tagnak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyListVouchers$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyListVouchers$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyMemberScopedRequest
  }): Observable<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse> {

    return this.loyaltyListVouchers$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse>) => r.body as BackendCoreApiModelsAppLoyaltyVoucherCollectionResponse)
    );
  }

  /**
   * Path part for operation loyaltyMarkNotificationRead
   */
  static readonly LoyaltyMarkNotificationReadPath = '/api/loyalty/notifications/read';

  /**
   * Üzenet olvasottnak jelölése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyMarkNotificationRead$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyMarkNotificationRead$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationActionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyMarkNotificationReadPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Üzenet olvasottnak jelölése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyMarkNotificationRead$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyMarkNotificationRead$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationActionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyMarkNotificationRead$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Üzenet olvasottnak jelölése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyMarkNotificationRead$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyMarkNotificationRead$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationActionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyMarkNotificationReadPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Üzenet olvasottnak jelölése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyMarkNotificationRead$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyMarkNotificationRead$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyNotificationActionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyMarkNotificationRead$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyRegister
   */
  static readonly LoyaltyRegisterPath = '/api/loyalty/register';

  /**
   * Szirom Pont tag regisztrációja.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyRegister$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRegister$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyRegisterRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyRegisterPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Szirom Pont tag regisztrációja.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyRegister$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRegister$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyRegisterRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyRegister$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Szirom Pont tag regisztrációja.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyRegister$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRegister$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyRegisterRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyRegisterPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Szirom Pont tag regisztrációja.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyRegister$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRegister$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyRegisterRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyRegister$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyRegisterDevice
   */
  static readonly LoyaltyRegisterDevicePath = '/api/loyalty/devices/register';

  /**
   * Push-token regisztrálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyRegisterDevice$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRegisterDevice$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRegisterDeviceRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyRegisterDevicePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Push-token regisztrálása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyRegisterDevice$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRegisterDevice$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRegisterDeviceRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyRegisterDevice$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Push-token regisztrálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyRegisterDevice$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRegisterDevice$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRegisterDeviceRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyRegisterDevicePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Push-token regisztrálása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyRegisterDevice$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRegisterDevice$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRegisterDeviceRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyRegisterDevice$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyReportMissingPoints
   */
  static readonly LoyaltyReportMissingPointsPath = '/api/loyalty/reports/create';

  /**
   * Hiányzó pont bejelentése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyReportMissingPoints$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyReportMissingPoints$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyReportMissingPointsRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyReportMissingPointsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Hiányzó pont bejelentése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyReportMissingPoints$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyReportMissingPoints$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyReportMissingPointsRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyReportMissingPoints$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Hiányzó pont bejelentése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyReportMissingPoints$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyReportMissingPoints$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyReportMissingPointsRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyReportMissingPointsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Hiányzó pont bejelentése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyReportMissingPoints$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyReportMissingPoints$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyReportMissingPointsRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyReportMissingPoints$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyRequestMembership
   */
  static readonly LoyaltyRequestMembershipPath = '/api/loyalty/memberships/request';

  /**
   * Tagság kérése további patikába.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyRequestMembership$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRequestMembership$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyRequestMembershipRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyRequestMembershipPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Tagság kérése további patikába.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyRequestMembership$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRequestMembership$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyRequestMembershipRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyRequestMembership$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Tagság kérése további patikába.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyRequestMembership$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRequestMembership$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyRequestMembershipRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyRequestMembershipPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Tagság kérése további patikába.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyRequestMembership$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRequestMembership$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyRequestMembershipRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyRequestMembership$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyRequestRedemption
   */
  static readonly LoyaltyRequestRedemptionPath = '/api/loyalty/redemptions/request';

  /**
   * Utalvány beváltásának kérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyRequestRedemption$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRequestRedemption$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRequestRedemptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyRequestRedemptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Utalvány beváltásának kérése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyRequestRedemption$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRequestRedemption$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRequestRedemptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyRequestRedemption$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Utalvány beváltásának kérése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyRequestRedemption$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRequestRedemption$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRequestRedemptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyRequestRedemptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Utalvány beváltásának kérése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyRequestRedemption$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyRequestRedemption$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRequestRedemptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyRequestRedemption$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyResendVerification
   */
  static readonly LoyaltyResendVerificationPath = '/api/loyalty/resend-verification';

  /**
   * Megerősítő kód újraküldése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyResendVerification$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyResendVerification$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyResendVerificationRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyResendVerificationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Megerősítő kód újraküldése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyResendVerification$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyResendVerification$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyResendVerificationRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyResendVerification$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Megerősítő kód újraküldése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyResendVerification$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyResendVerification$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyResendVerificationRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyResendVerificationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Megerősítő kód újraküldése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyResendVerification$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyResendVerification$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyResendVerificationRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyResendVerification$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminResolveMissingPointReport
   */
  static readonly LoyaltyAdminResolveMissingPointReportPath = '/api/loyalty/admin/reports/resolve';

  /**
   * Bejelentés elbírálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminResolveMissingPointReport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminResolveMissingPointReport$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyResolveMissingPointReportRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminResolveMissingPointReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Bejelentés elbírálása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminResolveMissingPointReport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminResolveMissingPointReport$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyResolveMissingPointReportRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminResolveMissingPointReport$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Bejelentés elbírálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminResolveMissingPointReport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminResolveMissingPointReport$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyResolveMissingPointReportRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminResolveMissingPointReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Bejelentés elbírálása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminResolveMissingPointReport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminResolveMissingPointReport$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyResolveMissingPointReportRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminResolveMissingPointReport$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminRevokeImportBatch
   */
  static readonly LoyaltyAdminRevokeImportBatchPath = '/api/loyalty/admin/import/revoke';

  /**
   * Pontfeltöltési köteg visszavonása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminRevokeImportBatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminRevokeImportBatch$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRevokeImportBatchRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminRevokeImportBatchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Pontfeltöltési köteg visszavonása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminRevokeImportBatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminRevokeImportBatch$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRevokeImportBatchRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminRevokeImportBatch$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Pontfeltöltési köteg visszavonása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminRevokeImportBatch$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminRevokeImportBatch$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRevokeImportBatchRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminRevokeImportBatchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Pontfeltöltési köteg visszavonása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminRevokeImportBatch$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminRevokeImportBatch$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyRevokeImportBatchRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminRevokeImportBatch$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminSaveCampaign
   */
  static readonly LoyaltyAdminSaveCampaignPath = '/api/loyalty/admin/campaigns/save';

  /**
   * Kampány mentése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSaveCampaign$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveCampaign$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveCampaignRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSaveCampaignPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Kampány mentése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSaveCampaign$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveCampaign$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveCampaignRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSaveCampaign$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Kampány mentése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSaveCampaign$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveCampaign$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveCampaignRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSaveCampaignPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Kampány mentése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSaveCampaign$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveCampaign$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveCampaignRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSaveCampaign$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminSaveCampaignItem
   */
  static readonly LoyaltyAdminSaveCampaignItemPath = '/api/loyalty/admin/campaign-items/save';

  /**
   * Kampánytermék mentése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSaveCampaignItem$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveCampaignItem$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveCampaignItemRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSaveCampaignItemPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse>;
      })
    );
  }

  /**
   * Kampánytermék mentése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSaveCampaignItem$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveCampaignItem$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveCampaignItemRequest
  }): Observable<BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse> {

    return this.loyaltyAdminSaveCampaignItem$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse>) => r.body as BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse)
    );
  }

  /**
   * Kampánytermék mentése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSaveCampaignItem$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveCampaignItem$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveCampaignItemRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSaveCampaignItemPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse>;
      })
    );
  }

  /**
   * Kampánytermék mentése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSaveCampaignItem$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveCampaignItem$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveCampaignItemRequest
  }): Observable<BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse> {

    return this.loyaltyAdminSaveCampaignItem$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse>) => r.body as BackendCoreApiModelsAppLoyaltySaveCampaignItemResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminSaveTraining
   */
  static readonly LoyaltyAdminSaveTrainingPath = '/api/loyalty/admin/trainings/save';

  /**
   * Oktatás mentése kérdésekkel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSaveTraining$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveTraining$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveTrainingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSaveTrainingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Oktatás mentése kérdésekkel.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSaveTraining$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveTraining$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveTrainingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSaveTraining$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Oktatás mentése kérdésekkel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSaveTraining$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveTraining$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveTrainingRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSaveTrainingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Oktatás mentése kérdésekkel.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSaveTraining$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveTraining$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveTrainingRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSaveTraining$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminSaveVoucher
   */
  static readonly LoyaltyAdminSaveVoucherPath = '/api/loyalty/admin/vouchers/save';

  /**
   * Utalvány mentése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSaveVoucher$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveVoucher$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveVoucherRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSaveVoucherPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Utalvány mentése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSaveVoucher$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveVoucher$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveVoucherRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSaveVoucher$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Utalvány mentése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSaveVoucher$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveVoucher$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveVoucherRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSaveVoucherPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Utalvány mentése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSaveVoucher$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSaveVoucher$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltySaveVoucherRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSaveVoucher$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminSendNotification
   */
  static readonly LoyaltyAdminSendNotificationPath = '/api/loyalty/admin/notifications/send';

  /**
   * Üzenet küldése tagoknak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSendNotification$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSendNotification$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySendNotificationRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSendNotificationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Üzenet küldése tagoknak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSendNotification$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSendNotification$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltySendNotificationRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSendNotification$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Üzenet küldése tagoknak.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSendNotification$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSendNotification$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySendNotificationRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSendNotificationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Üzenet küldése tagoknak.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSendNotification$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSendNotification$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltySendNotificationRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSendNotification$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminSetPharmacy
   */
  static readonly LoyaltyAdminSetPharmacyPath = '/api/loyalty/admin/pharmacies/set';

  /**
   * Patika részvételének beállítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSetPharmacy$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSetPharmacy$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySetPharmacyProgramRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSetPharmacyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Patika részvételének beállítása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSetPharmacy$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSetPharmacy$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltySetPharmacyProgramRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSetPharmacy$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Patika részvételének beállítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminSetPharmacy$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSetPharmacy$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySetPharmacyProgramRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminSetPharmacyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Patika részvételének beállítása.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminSetPharmacy$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyAdminSetPharmacy$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltySetPharmacyProgramRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminSetPharmacy$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltySubmitTraining
   */
  static readonly LoyaltySubmitTrainingPath = '/api/loyalty/trainings/submit';

  /**
   * Kérdőív beküldése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltySubmitTraining$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltySubmitTraining$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySubmitTrainingRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltySubmitTrainingResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltySubmitTrainingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltySubmitTrainingResponse>;
      })
    );
  }

  /**
   * Kérdőív beküldése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltySubmitTraining$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltySubmitTraining$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltySubmitTrainingRequest
  }): Observable<BackendCoreApiModelsAppLoyaltySubmitTrainingResponse> {

    return this.loyaltySubmitTraining$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltySubmitTrainingResponse>) => r.body as BackendCoreApiModelsAppLoyaltySubmitTrainingResponse)
    );
  }

  /**
   * Kérdőív beküldése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltySubmitTraining$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltySubmitTraining$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltySubmitTrainingRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppLoyaltySubmitTrainingResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltySubmitTrainingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppLoyaltySubmitTrainingResponse>;
      })
    );
  }

  /**
   * Kérdőív beküldése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltySubmitTraining$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltySubmitTraining$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltySubmitTrainingRequest
  }): Observable<BackendCoreApiModelsAppLoyaltySubmitTrainingResponse> {

    return this.loyaltySubmitTraining$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppLoyaltySubmitTrainingResponse>) => r.body as BackendCoreApiModelsAppLoyaltySubmitTrainingResponse)
    );
  }

  /**
   * Path part for operation loyaltyUnregisterDevice
   */
  static readonly LoyaltyUnregisterDevicePath = '/api/loyalty/devices/unregister';

  /**
   * Push-token törlése (kijelentkezés).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyUnregisterDevice$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyUnregisterDevice$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyUnregisterDeviceRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyUnregisterDevicePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Push-token törlése (kijelentkezés).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyUnregisterDevice$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyUnregisterDevice$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyUnregisterDeviceRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyUnregisterDevice$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Push-token törlése (kijelentkezés).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyUnregisterDevice$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyUnregisterDevice$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyUnregisterDeviceRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyUnregisterDevicePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Push-token törlése (kijelentkezés).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyUnregisterDevice$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyUnregisterDevice$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyUnregisterDeviceRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyUnregisterDevice$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyAdminUploadCampaignItemImage
   */
  static readonly LoyaltyAdminUploadCampaignItemImagePath = '/api/loyalty/admin/campaign-items/upload-image';

  /**
   * Kampánytermék képének feltöltése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminUploadCampaignItemImage$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  loyaltyAdminUploadCampaignItemImage$Plain$Response(params?: {
    body?: {
'CorrelationId'?: string;
'Id': number;
'File': Blob;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminUploadCampaignItemImagePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Kampánytermék képének feltöltése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminUploadCampaignItemImage$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  loyaltyAdminUploadCampaignItemImage$Plain(params?: {
    body?: {
'CorrelationId'?: string;
'Id': number;
'File': Blob;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminUploadCampaignItemImage$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Kampánytermék képének feltöltése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyAdminUploadCampaignItemImage$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  loyaltyAdminUploadCampaignItemImage$Json$Response(params?: {
    body?: {
'CorrelationId'?: string;
'Id': number;
'File': Blob;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyAdminUploadCampaignItemImagePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Kampánytermék képének feltöltése.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyAdminUploadCampaignItemImage$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  loyaltyAdminUploadCampaignItemImage$Json(params?: {
    body?: {
'CorrelationId'?: string;
'Id': number;
'File': Blob;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyAdminUploadCampaignItemImage$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation loyaltyVerifyEmail
   */
  static readonly LoyaltyVerifyEmailPath = '/api/loyalty/verify-email';

  /**
   * E-mail megerősítése kóddal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyVerifyEmail$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyVerifyEmail$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyVerifyEmailRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyVerifyEmailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * E-mail megerősítése kóddal.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyVerifyEmail$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyVerifyEmail$Plain(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyVerifyEmailRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyVerifyEmail$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * E-mail megerősítése kóddal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loyaltyVerifyEmail$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyVerifyEmail$Json$Response(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyVerifyEmailRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, LoyaltyBackendService.LoyaltyVerifyEmailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * E-mail megerősítése kóddal.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loyaltyVerifyEmail$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  loyaltyVerifyEmail$Json(params?: {
    body?: BackendCoreApiModelsAppLoyaltyLoyaltyVerifyEmailRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.loyaltyVerifyEmail$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
